export default __webpack_public_path__ + "static/business-insider-441efa36f42c5fd9c2b5b7757e33cb46.svg";